import { createPortal } from 'react-dom'
import { CheckCircle2, Info, XCircle } from 'lucide-react'
import { useUI } from '../../store/ui'
import { cn } from '../../lib/cn'

const ICONOS = {
  exito: CheckCircle2,
  error: XCircle,
  info: Info,
}

const TONOS = {
  exito: 'text-lima-400',
  error: 'text-rojo-400',
  info: 'text-tinta-200',
}

/** Los avisos aparecen arriba en teléfono (donde está el pulgar no
 *  tapa nada) y abajo a la derecha en escritorio. */
export function Avisos() {
  const { avisos, cerrarAviso } = useUI()
  if (!avisos.length) return null

  return createPortal(
    <div className="pointer-events-none fixed inset-x-0 top-0 z-[60] flex flex-col items-center gap-2 p-4 safe-top sm:inset-x-auto sm:top-auto sm:right-6 sm:bottom-6 sm:items-end">
      {avisos.map((a) => {
        const Icono = ICONOS[a.tono]
        return (
          <div
            key={a.id}
            className={cn(
              'pointer-events-auto flex w-full max-w-sm items-center gap-1 rounded-2xl py-1.5 pr-1.5 pl-1',
              'bg-piedra-900 text-piedra-50 sombra-flotante anim-aparecer dark:bg-piedra-800',
            )}
          >
            <button
              onClick={() => cerrarAviso(a.id)}
              className="flex min-w-0 flex-1 items-center gap-3 rounded-xl px-3 py-2 text-left"
            >
              <Icono className={cn('size-5 shrink-0', TONOS[a.tono])} />
              <span className="text-sm font-medium">{a.texto}</span>
            </button>
            {a.accion && (
              <button
                onClick={() => {
                  a.accion?.ejecutar()
                  cerrarAviso(a.id)
                }}
                className="shrink-0 rounded-xl px-3 py-2 text-sm font-bold text-lima-300 transition-colors hover:bg-white/10"
              >
                {a.accion.texto}
              </button>
            )}
          </div>
        )
      })}
    </div>,
    document.body,
  )
}
